// TODO: duplicated base colour definitions.
// We could probably user https://amzn.github.io/style-dictionary/ and define everything there.
const LMG_BLUE = '#0054A6';
// const LMG_YELLOW = '#FFDD00'; // never read here
const LMG_RED = '#ED1A3B';
const LMG_BLACK = '#000000';
const LMG_WHITE = '#FFFFFF';
const LMG_LIGHT_GREY = 'lightgrey';
const LMG_PLACEHOLDER_GREY = '#B8B8B8';
const LMG_DISABLED_GREY = '#666666';

const THIRSTY_CAMEL_GREEN = '#A0CE66';
const THIRSTY_CAMEL_GREEN_HIGHLIGHT = '#7AC142';
const THIRSTY_CAMEL_RED = '#CD003A';
// const THIRSTY_CAMEL_GREEN_WELLCOM = '#ACCA57';

const PRIMARY_COLOUR = THIRSTY_CAMEL_GREEN;
const SECONDARY_COLOUR = THIRSTY_CAMEL_RED;
const HIGHLIGHT_COLOUR = LMG_RED;

const theme = {
  colour: {
    general: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
      highlight: HIGHLIGHT_COLOUR,
    },
    uiControls: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
    },
    text: {
      heading: {
        primary: LMG_BLACK,
      },
      content: {
        primary: LMG_BLACK,
      },
      link: {
        primary: LMG_BLUE,
      },
      menu: {
        primary: LMG_WHITE,
      },
      form: {
        textInput: {
          primary: LMG_BLACK,
          placeholder: LMG_PLACEHOLDER_GREY,
        },
      },
      drawer: {
        primary: LMG_BLACK,
      },
      button: {
        attention: THIRSTY_CAMEL_RED,
        disabled: LMG_DISABLED_GREY,
      },
      hero: {
        header: LMG_WHITE,
      },
      tabIcons: {
        cart: {
          priceBadge: LMG_WHITE,
        },
      },
      tile: {
        name: LMG_BLACK,
        byline: '#666666',
        price: THIRSTY_CAMEL_RED,
        priceSecondary: '#666666',
        button: LMG_WHITE,
      },
    },
    border: {
      general: {
        primary: PRIMARY_COLOUR,
      },
      appRoot: {
        primary: LMG_BLUE,
      },
      tile: '#CCCCCC',
    },
    icon: {
      general: {
        primary: PRIMARY_COLOUR,
        secondary: SECONDARY_COLOUR,
      },
      header: {
        primary: LMG_WHITE,
      },
    },
    background: {
      general: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_BLACK,
        secondary: SECONDARY_COLOUR,
      },
      button: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_WHITE,
        disabled: LMG_LIGHT_GREY,
      },
      hero: {
        header: THIRSTY_CAMEL_RED,
      },
      drawer: THIRSTY_CAMEL_GREEN_HIGHLIGHT,
      feedTile: {
        promotion: THIRSTY_CAMEL_GREEN,
      },
      range: {
        tileContainer: THIRSTY_CAMEL_GREEN_HIGHLIGHT,
      },
      tile: {
        surface: LMG_WHITE,
        buttonDisabled: LMG_WHITE,
      },
      memberPriceBadge: '#FFDD00',
    },
    activityIndicator: {
      primary: PRIMARY_COLOUR,
    },
    checkbox: {
      primary: THIRSTY_CAMEL_RED,
    },
    navTab: {
      barBg: LMG_WHITE,
      activeBg: THIRSTY_CAMEL_GREEN,
      activeText: LMG_BLACK,
      inactiveText: LMG_BLACK,
    },
    desktopNavTab: {
      activeBg: THIRSTY_CAMEL_RED,
      activeText: LMG_WHITE,
      inactiveText: LMG_BLACK,
    },
    creditCard: {
      background: THIRSTY_CAMEL_RED,
      text: LMG_WHITE,
      textMuted: 'rgba(255,255,255,0.7)',
      chip: '#D4AF37',
    },
  },
  size: {
    text: {
      body1: 18,
      body2: 16,
      heading0: 24,
      heading1: 20,
      heading2: 18,
      heading3: 16,
      heading4: 14,
      caption: 14,
    },
    badge: {
      type: 'circle',
      color: '#ED1A3B',
      titleFontSize: 10,
      titleFontSizeLong: 8,
      priceFontSize: 13,
      dollarSignFontSize: 11,
      chevronHeight: 8,
      contentPadding: 3,
      titlePaddingVertical: 2,
      titlePaddingHorizontal: 3,
      pricePaddingVertical: 6,
      textY: 20,
      priceYWithText: 32,
      priceYNoText: 28,
    },
    // Banner geometry — DIS-1181 (web 1300×400) + DIS-1182 (mobile 760×500).
    // Stored as raw width/height; consumers derive aspectRatio = width / height.
    banner: {
      web: {width: 1300, height: 400, maxWidth: 1300, maxHeight: 400},
      mobile: {width: 760, height: 500},
    },
  },
  typography: {
    fontFamily: 'Rubik',
    fontFamilyBold: 'Rubik-Bold',
    weights: {
      light: {fileName: 'Rubik-Light', weight: 300, style: 'normal'},
      regular: {fileName: 'Rubik-Regular', weight: 400, style: 'normal'},
      medium: {fileName: 'Rubik-Medium', weight: 500, style: 'normal'},
      semiBold: {fileName: 'Rubik-SemiBold', weight: 600, style: 'normal'},
      bold: {fileName: 'Rubik-Bold', weight: 700, style: 'normal'},
      extraBold: {fileName: 'Rubik-ExtraBold', weight: 800, style: 'normal'},
    },
  },
};

export default theme;
